import React from "react";
import { Grid } from "@mui/material";

import useSubscriptionLogTable from "components/pages/transmissions/modal/patient/tabs/subscription/log/useSubscriptionLogTable";
import CommunicationLog from "components/common/communicationLog/CommunicationLog";

const SubscriptionLogTable = ({ type, title }) => {
  const { data, isLoading } = useSubscriptionLogTable(type);

  return (
    <Grid container spacing={3}>
      {title && (
        <Grid item style={{ paddingBottom: 0 }}>
          <div className="patient-form__info--header">{title}</div>
        </Grid>
      )}
      <Grid item xs={12} id="patientTable">
        <CommunicationLog data={data?.logs || []} isLoading={isLoading} />
      </Grid>
    </Grid>
  );
};

export default SubscriptionLogTable;
